/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'company-hub.section-extension.config-panel.background-color-field.background-color': '背景顏色',
  'company-hub.section-extension.config-panel.content-width-field.full-label': '完整',
  'company-hub.section-extension.config-panel.content-width-field.full-tooltip': '全寬',
  'company-hub.section-extension.config-panel.content-width-field.label': '內容寬度',
  'company-hub.section-extension.config-panel.content-width-field.narrow-label': '窄',
  'company-hub.section-extension.config-panel.content-width-field.narrow-tooltip': '窄',
  'company-hub.section-extension.config-panel.content-width-field.wide-label': '寬',
  'company-hub.section-extension.config-panel.content-width-field.wide-tooltip': '寬',
  'company-hub.section-extension.config-panel.preamble': '將元素整理成可自訂的區段。{supportLink}',
  'company-hub.section-extension.config-panel.preamble-link.label': '進一步了解如何設計您的中心。',
  'company-hub.section-extension.config-panel.preamble-without-support-link':
    '透過可自訂的背景和風格設定，將相關元素整理成不同區段。',
  'company-hub.section-extension.config-panel.title': '區段',
  'company-hub.section-extension.error-loading-content': '載入內容時發生錯誤',
  'company-hub.section-extension.manifest.content.header': '為您的區域命名',
  'company-hub.section-extension.manifest.content.placeholder-title': '預留位置',
  'company-hub.section-extension.manifest.content.sub-header': '透過可自訂的背景，將元素整理成區段。',
  'company-hub.section-extension.manifest.extension-lozenge-title': '區段',
  'company-hub.section-extension.manifest.extension-title': '區段 [新]',
  'company-hub.section-extension.manifest.macro-description': '透過背景將元素分組',
};
